module.exports = __webpack_public_path__ + "img/img3.e2757980.jpg";